<div class="alert-period-tab">
  
  <!-- 未処理ブロック -->
  <div class="alert-block unprocessed-block" *ngIf="showUnprocessedBlock">
    <h2 class="block-title">勤務期間アラートリスト（未処理）</h2>
    
    <div class="table-container">
      <table class="alert-table">
        <thead>
          <tr>
            <th class="text-center">処理</th>
            <th class="text-center">AID</th>
            <th class="text-center">獲注番号</th>
            <th class="text-center">スタッフ番号</th>
            <th class="text-center">部署コード</th>
            <th class="text-center">元開始日</th>
            <th class="text-center">元終了日</th>
            <th class="text-center">新開始日</th>
            <th class="text-center">新終了日</th>
            <th class="text-center">発生日</th>
            <th class="text-center">状態</th>
            <th class="text-center">前払い</th>
            <th>支店担当者</th>
            <th class="text-center">処理内容</th>
            <th class="text-center">処理状況</th>
            <th>処理担当者</th>
            <th class="text-center">処理日時</th>
            <th class="text-center">メール送信日時</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let alert of unprocessedAlerts">
            <td class="text-center">
              <button class="btn btn-primary btn-sm" (click)="onShowDetail(alert)">表示</button>
            </td>
            <td class="text-center">
              <ng-container *ngIf="alert.procStatus !== '未処理'">
                <a (click)="navigateToTransfer(alert.odchgID)"
                   style="color: #007bff; text-decoration: underline; cursor: pointer;">
                  {{alert.odchgID}}
                </a>
              </ng-container>
              <ng-container *ngIf="alert.procStatus === '未処理'">
                {{alert.odchgID}}
              </ng-container>
            </td>
            <td class="text-center">
              <a href="javascript:void(0)" (click)="navigateToJobOrderInfo(alert.jobOrderID)">
                {{alert.jobOrderID}}
              </a>
            </td>
            <td class="text-center">
              <a href="javascript:void(0)" (click)="navigateToAscInfo({userCode: alert.userCode})">
                {{alert.userCode}}
              </a>
            </td>
            <td class="text-center">
              <a href="javascript:void(0)" (click)="navigateToCustomerInfo(alert.customerOfficeID)">
                {{alert.customerOfficeCode}}
              </a>
            </td>
            <td class="text-center">{{alert.oldStartDate}}</td>
            <td class="text-center">{{alert.oldEndDate}}</td>
            <td class="text-center">{{alert.newStartDate}}</td>
            <td class="text-center">{{alert.newEndDate}}</td>
            <td class="text-center">{{alert.createDate}}</td>
            <td class="text-center">{{alert.dataState}}</td>
            <td class="text-center">{{alert.prePay}}</td>
            <td>{{alert.repName}}</td>
            <td class="text-center">{{alert.procStatus}}</td>
            <td class="text-center">{{alert.status}}</td>
            <td>{{alert.procUserName}}</td>
            <td class="text-center">{{alert.procDate}}</td>
            <td class="text-center">{{alert.sendDate}}</td>
          </tr>
          <tr *ngIf="unprocessedAlerts.length === 0">
            <td colspan="18" class="text-center">未処理のデータはありません</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ページング -->
    <div class="pagination-container" *ngIf="unprocessedTotalPages > 1">
      <button class="btn btn-sm" [disabled]="unprocessedPageNo === 1" (click)="onUnprocessedPageChange(1)">
        &lt;&lt;
      </button>
      <button class="btn btn-sm" [disabled]="unprocessedPageNo === 1" (click)="onUnprocessedPageChange(unprocessedPageNo - 1)">
        &lt;
      </button>
      <button 
        *ngFor="let page of getUnprocessedPageNumbers()" 
        class="btn btn-sm"
        [class.active]="page === unprocessedPageNo"
        (click)="onUnprocessedPageChange(page)">
        {{ page }}
      </button>
      <button class="btn btn-sm" [disabled]="unprocessedPageNo === unprocessedTotalPages" (click)="onUnprocessedPageChange(unprocessedPageNo + 1)">
        &gt;
      </button>
      <button class="btn btn-sm" [disabled]="unprocessedPageNo === unprocessedTotalPages" (click)="onUnprocessedPageChange(unprocessedTotalPages)">
        &gt;&gt;
      </button>
      <span class="page-info">{{ unprocessedPageNo }} / {{ unprocessedTotalPages }} ページ (全{{ unprocessedTotalRecords }}件)</span>
    </div>
  </div>

  <!-- アラート内容ブロック -->
  <div class="alert-block detail-block" *ngIf="showDetailBlock">
    <h2 class="block-title">アラート内容 &nbsp; AID: {{ selectedAlert?.odchgID }} &nbsp; 処理状況: {{ selectedAlert?.status }}</h2>

    <table class="summary-table">
      <tbody>
        <tr>
          <th>獲注番号</th>
          <td class="col-compact">
            <a href="javascript:void(0)" (click)="navigateToJobOrderInfo(selectedAlert.jobOrderID)">{{ selectedAlert?.jobOrderID }}</a>
          </td>
          <th>発生日時</th>
          <td class="col-compact">{{ selectedAlert?.createDate }}</td>
          <th>支店担当者</th>
          <td class="col-text">{{ selectedAlert?.repName }}</td>
        </tr>
        <tr>
          <th>元の契約期間</th>
          <td class="col-compact">{{ selectedAlert?.oldStartDate }}～{{ selectedAlert?.oldEndDate }}<ng-container *ngIf="selectedAlert?.dtStartDate"> ({{ selectedAlert?.dtStartDate }}～{{ selectedAlert?.dtEndDate }})</ng-container></td>
          <th>スタッフ番号</th>
          <td class="col-compact">
            <a href="javascript:void(0)" (click)="navigateToAscInfo({userCode: selectedAlert.userCode})">{{ selectedAlert?.userCode }}</a>
          </td>
          <th>スタッフ氏名</th>
          <td class="col-text">{{ selectedAlert?.staffName }}</td>
        </tr>
        <tr>
          <th>更新契約期間</th>
          <td class="col-compact">{{ selectedAlert?.newStartDate }}～{{ selectedAlert?.newEndDate }}</td>
          <th>部署</th>
          <td colspan="3">
            <a href="javascript:void(0)" (click)="navigateToCustomerInfo(selectedAlert.customerOfficeID)">{{ selectedAlert?.customerOfficeCode }}</a>
            {{ selectedAlert?.customerName }}
          </td>
        </tr>
      </tbody>
    </table>

    <!-- メモエリア -->
    <div class="memo-area">
      <label>メモ</label>
      <textarea [(ngModel)]="selectedAlert.procComment" class="memo-input" rows="1"></textarea>
      <button class="btn btn-sm btn-save" (click)="saveSelectedMemo()">保存</button>
    </div>

    <!-- 状態・BP確認・修正期間・アクションボタン -->
    <div class="status-action-area">
      <span class="status-badge">状態：[{{ selectedAlert?.dataState }}]</span>
      <label class="bp-check-label">
        BP確認
        <input type="checkbox" [checked]="selectedAlert?.bpchk === 1" (change)="onDetailBPchkChange($event)">
      </label>
      <span class="period-label">修正期間：</span>
      <input type="text" class="date-input" [(ngModel)]="editStartDate" placeholder="yyyy/mm/dd" (change)="onEditDateChange('start')">
      <span>～</span>
      <input type="text" class="date-input" [(ngModel)]="editEndDate" placeholder="yyyy/mm/dd" (change)="onEditDateChange('end')">
      <button class="btn btn-danger"
        [disabled]="selectedAlert?.bpchk !== 1"
        (click)="deleteTimesheet(selectedAlert)">
        TS削除
      </button>
      <button class="btn btn-secondary"
        [disabled]="selectedAlert?.bpchk !== 1"
        (click)="executeAlternative(selectedAlert)">
        別処理
      </button>
      <button class="btn btn-success"
        [disabled]="!selectedAlert?.procStatus"
        (click)="completeProcess(selectedAlert)">
        完了
      </button>
      <button class="btn btn-close-detail" (click)="onCloseDetail()">閉じる</button>
    </div>
  </div>

  <!-- 処理済みブロック -->
  <div class="alert-block processed-block">
    <h2 class="block-title">勤務期間アラートリスト（処理済）</h2>
    
    <div class="filter-compact">
      <label class="radio-label">
        <input type="radio" name="period" value="today" 
          [(ngModel)]="selectedPeriod" (change)="onPeriodChange('today')">
        <span>本日</span>
      </label>
      <label class="radio-label">
        <input type="radio" name="period" value="week" 
          [(ngModel)]="selectedPeriod" (change)="onPeriodChange('week')">
        <span>1週間</span>
      </label>
      <label class="radio-label">
        <input type="radio" name="period" value="month" 
          [(ngModel)]="selectedPeriod" (change)="onPeriodChange('month')">
        <span>1か月</span>
      </label>
      <button class="btn btn-success csv-btn" (click)="exportProcessedAlertsToCSV()">CSV出力</button>
    </div>

    <div class="table-container">
      <table class="alert-table">
        <thead>
          <tr>
            <th class="text-center">AID</th>
            <th class="text-center">獲注番号</th>
            <th class="text-center">スタッフ番号</th>
            <th class="text-center">部署コード</th>
            <th class="text-center">元開始日</th>
            <th class="text-center">元終了日</th>
            <th class="text-center">新開始日</th>
            <th class="text-center">新終了日</th>
            <th class="text-center">発生日</th>
            <th class="text-center">状態</th>
            <th class="text-center">前払い</th>
            <th>支店担当者</th>
            <th class="text-center">処理内容</th>
            <th class="text-center">処理状況</th>
            <th>処理担当者</th>
            <th class="text-center">処理日時</th>
            <th class="text-center">メール送信日時</th>
            <th class="text-center">差戻し</th>
            <th>メモ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let alert of processedAlerts">
            <td class="text-center">
              <a (click)="navigateToTransfer(alert.odchgID)" 
                 style="color: #007bff; text-decoration: underline; cursor: pointer;">
                {{alert.odchgID}}
              </a>
            </td>
            <td class="text-center">
              <a href="javascript:void(0)" (click)="navigateToJobOrderInfo(alert.jobOrderID)">
                {{alert.jobOrderID}}
              </a>
            </td>
            <td class="text-center">
              <a href="javascript:void(0)" (click)="navigateToAscInfo({userCode: alert.userCode})">
                {{alert.userCode}}
              </a>
            </td>
            <td class="text-center">
              <a href="javascript:void(0)" (click)="navigateToCustomerInfo(alert.customerOfficeID)">
                {{alert.customerOfficeCode}}
              </a>
            </td>
            <td class="text-center">{{alert.oldStartDate}}</td>
            <td class="text-center">{{alert.oldEndDate}}</td>
            <td class="text-center">{{alert.newStartDate}}</td>
            <td class="text-center">{{alert.newEndDate}}</td>
            <td class="text-center">{{alert.createDate}}</td>
            <td class="text-center">{{alert.dataState}}</td>
            <td class="text-center">{{alert.prePay}}</td>
            <td>{{alert.repName}}</td>
            <td class="text-center">{{alert.procStatus}}</td>
            <td class="text-center">{{alert.status}}</td>
            <td>{{alert.procUserName}}</td>
            <td class="text-center">{{alert.procDate}}</td>
            <td class="text-center">{{alert.AlertSentDate}}</td>
            <td class="text-center">
              <button class="btn btn-warning btn-sm" (click)="rejectProcess(alert)">
                差戻し
              </button>
            </td>
            <td class="memo-display">{{alert.procComment}}</td>
          </tr>
          <tr *ngIf="processedAlerts.length === 0">
            <td colspan="19" class="text-center">処理済みのデータはありません</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ページング -->
    <div class="pagination-container" *ngIf="processedTotalPages > 1">
      <button 
        class="page-btn" 
        [disabled]="processedPageNo === 1"
        (click)="onProcessedPageChange(processedPageNo - 1)">
        前へ
      </button>
      
      <button 
        *ngFor="let page of getProcessedPageNumbers()"
        class="page-btn" 
        [class.active]="processedPageNo === page"
        (click)="onProcessedPageChange(page)">
        {{ page }}
      </button>
      
      <button 
        class="page-btn" 
        [disabled]="processedPageNo === processedTotalPages"
        (click)="onProcessedPageChange(processedPageNo + 1)">
        次へ
      </button>
      
      <span class="page-info">
        {{ processedPageNo }} / {{ processedTotalPages }} ページ
      </span>
    </div>
  </div>

  <!-- その他のアラートリストブロック -->
  <div class="alert-block other-alerts-block">
    <h2 class="block-title">その他のアラートリスト</h2>
    
    <div class="filter-compact">
      期間：
      <label class="radio-label">
        <input type="radio" name="otherPeriod" value="today" 
          [(ngModel)]="otherAlertsPeriod" (change)="onOtherAlertsPeriodChange('today')">
        <span>本日</span>
      </label>
      <label class="radio-label">
        <input type="radio" name="otherPeriod" value="week" 
          [(ngModel)]="otherAlertsPeriod" (change)="onOtherAlertsPeriodChange('week')">
        <span>1週間</span>
      </label>
      <label class="radio-label">
        <input type="radio" name="otherPeriod" value="month" 
          [(ngModel)]="otherAlertsPeriod" (change)="onOtherAlertsPeriodChange('month')">
        <span>1か月</span>
      </label>
      　｜　状態：
      <label class="radio-label">
        <input type="radio" name="otherStatus" value="unprocessed" 
          [(ngModel)]="otherAlertsStatus" (change)="onOtherAlertsStatusChange('unprocessed')">
        <span>未処理</span>
      </label>
      <label class="radio-label">
        <input type="radio" name="otherStatus" value="completed"
          [(ngModel)]="otherAlertsStatus" (change)="onOtherAlertsStatusChange('completed')">
        <span>完了</span>
      </label>
      <label class="radio-label">
        <input type="radio" name="otherStatus" value="all" 
          [(ngModel)]="otherAlertsStatus" (change)="onOtherAlertsStatusChange('all')">
        <span>すべて</span>
      </label>      
      <button class="btn btn-success csv-btn" (click)="exportOtherAlertsToCSV()">CSV出力</button>
    </div>
    <div class="table-container">
      <table class="alert-table">
        <thead>
          <tr>
            <th class="text-center">AID</th>
            <th class="text-center">現獲注番号</th>
            <th class="text-center">新獲注番号</th>
            <th class="text-center">スタッフ番号</th>
            <th class="text-center">部署コード</th>
            <th>エラー内容</th>
            <th class="text-center">メール送信日時</th>
            <th>支店担当者</th>
            <th class="text-center">確認</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let alert of otherAlerts">
            <td class="text-center">{{alert.odchgID}}</td>
            <td class="text-center">
              <ng-container *ngIf="canNavigateCurrentJobOrder(alert); else currentJobOrderText">
                <a href="javascript:void(0)" (click)="navigateToJobOrderInfo(alert.jobOrderID)">
                  {{alert.jobOrderID}}
                </a>
              </ng-container>
              <ng-template #currentJobOrderText>
                {{alert.jobOrderID}}
              </ng-template>
            </td>
            <td class="text-center">{{alert.newJobOrderID}}</td>
            <td class="text-center">
              <a href="javascript:void(0)" (click)="navigateToAscInfo({userCode: alert.staffCode})">
                {{alert.staffCode}}
              </a>
            </td>
            <td class="text-center">{{alert.clientCode}}</td>
            <td>{{alert.procComment}}</td>
            <td class="text-center">{{alert.sendDate}}</td>
            <td>{{alert.repName}}</td>
            <td class="text-center">
              <button class="btn btn-warning btn-sm" (click)="confirmProcess(alert)">
                完了
              </button>
            </td>
          </tr>
          <tr *ngIf="otherAlerts.length === 0">
            <td colspan="9" class="text-center">データはありません</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ページング -->
    <div class="pagination-container" *ngIf="otherAlertsTotalPages > 1">
      <button 
        class="page-btn" 
        [disabled]="otherAlertsPageNo === 1"
        (click)="onOtherAlertsPageChange(otherAlertsPageNo - 1)">
        前へ
      </button>
      
      <button 
        *ngFor="let page of getOtherAlertsPageNumbers()"
        class="page-btn" 
        [class.active]="otherAlertsPageNo === page"
        (click)="onOtherAlertsPageChange(page)">
        {{ page }}
      </button>
      
      <button 
        class="page-btn" 
        [disabled]="otherAlertsPageNo === otherAlertsTotalPages"
        (click)="onOtherAlertsPageChange(otherAlertsPageNo + 1)">
        次へ
      </button>
      
      <span class="page-info">
        {{ otherAlertsPageNo }} / {{ otherAlertsTotalPages }} ページ
      </span>
    </div>
  </div>
</div>
